module.exports = __webpack_public_path__ + "img/17.96211098.jpg";